var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLanguage = function SvgLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.328 28.328"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Language_svg__linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })), /*#__PURE__*/React.createElement("style", null, ".Language_svg__cls-3{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Language_svg__Language",
    transform: "translate(-38.566 -527.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Language_svg__Text_Enabled",
    "data-name": "Text Enabled",
    transform: "translate(39.066 527.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Language_svg__Group_500",
    "data-name": "Group 500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Language_svg__Group_503",
    "data-name": "Group 503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Language_svg__Group_495",
    "data-name": "Group 495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Language_svg__Group_164",
    "data-name": "Group 164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Language_svg__Image",
    transform: "translate(3.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Language_svg__Icon_material-image",
    fill: "url(#Language_svg__linear-gradient)",
    d: "M28.261 28.791V7.536a2.868 2.868 0 00-2.64-3.036H7.14A2.868 2.868 0 004.5 7.536v21.255a2.868 2.868 0 002.64 3.036h18.481a2.868 2.868 0 002.64-3.036z",
    "data-name": "Icon material-image",
    transform: "translate(-4.5 -4.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Language_svg__Image-2",
    "data-name": "Image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Language_svg__Icon_material-image-2",
    fill: "none",
    stroke: "#000",
    d: "M31.828 28.791V7.536A3.045 3.045 0 0028.791 4.5H7.536A3.045 3.045 0 004.5 7.536v21.255a3.045 3.045 0 003.036 3.036h21.255a3.045 3.045 0 003.037-3.036zm-9.869-10.627z",
    "data-name": "Icon material-image",
    transform: "translate(-4.5 -4.5)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Language_svg__Subtraction_11",
    d: "M2.432 9.408H0L3.514 0h2.031l3.57 9.4h-2.53l-.536-1.77H2.967L2.433 9.4zM4.507 2.66L3.488 5.921H5.6L4.507 2.66z",
    className: "Language_svg__cls-3",
    "data-name": "Subtraction 11",
    transform: "translate(12.771 10.248)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Language_svg__Subtraction_25",
    d: "M9930-1541.127V-1555v13.87zm3.027-5.639a3.357 3.357 0 01-2.91-1.405l1.261-1.156a1.958 1.958 0 001.677 1.038.977.977 0 001.091-.989c0-.578-.438-.9-1.235-.9h-.7v-1.518h.454c.721 0 1.118-.355 1.118-1a.837.837 0 00-.908-.859 1.233 1.233 0 00-1.118.649l-1.144-1.078a2.615 2.615 0 011.612-1.018h1.428a2.1 2.1 0 011.808 2.127 1.794 1.794 0 01-.948 1.675v.05a1.619 1.619 0 01.441.16h.013a.3.3 0 00.08.05 2.231 2.231 0 001.038.26 2.243 2.243 0 001.041-.22v-2.688h-1.014V-1555h4.211v1.413h-1.365v1.79l-1.832 4.162v-1.718a1.974 1.974 0 01-.587.092 1.685 1.685 0 01-.637-.13v.077a2.579 2.579 0 01-2.872 2.548z",
    className: "Language_svg__cls-3",
    "data-name": "Subtraction 25",
    transform: "translate(-9885.092 2089.002)"
  }))));
};
export default SvgLanguage;